function init () {
}

export default {
  init
}
